import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import My from './views/My.vue';
import ActHome from './views/ActHome.vue';
import ActMy from './views/ActMy.vue';
import ActHomeV2 from './views/ActHomeV2.vue';
import ActMyV2 from './views/ActMyV2.vue';
Vue.use(Router)
export default new Router({
  mode: 'history',
  base: process.env.VUE_APP_ROUTER_BASE_URL,
  routes: [
    {
      path: '/:actId',
      name: 'home',
      component: ActHome,
      props: route => ({
        actId: Number(route.params.actId),
      })
    },
    {
      path: '/v1/:actId',
      name: 'home',
      component: ActHome,
      props: route => ({
        actId: Number(route.params.actId),
      })
    },
    {
      path: '/v2/:actId',
      name: 'homev2',
      component: ActHomeV2,
      props: route => ({
        actId: Number(route.params.actId),
      })
    },
    {
      path: '/v2/:actId/my',
      name: 'myv2',
      component: ActMyV2,
      props: route => ({
        actId: Number(route.params.actId),
      })
    },
    {
      path: '/:actId/my',
      name: 'my',
      component: ActMy,
      props: route => ({
        actId: Number(route.params.actId),
      })
    },
    {
      path: '/distribution/:distributionId',
      name: 'distributionHome',
      component: Home,
      props: route => ({
        distributionId: Number(route.params.distributionId),
      })
    },
    {
      path: '/distribution/:distributionId/my',
      name: 'distributionMy',
      component: My,
      props: route => ({
        distributionId: Number(route.params.distributionId),
      })
    },
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
})
